import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const services = [
  {
    title: "User Research",
    description: "Understand user needs, behaviors, and motivations through research techniques.",
    imgUrl: "./img/services/ui-ux/user-research.png",
  },
  {
    title: "Wireframing & Prototyping",
    description: "Plan and create prototypes to visualize and test ideas effectively.",
    imgUrl: "./img/services/ui-ux/wireframing-and-prototyping.jpg",
  },
  {
    title: "Visual Design",
    description: "Focus on aesthetics and aligning designs with brand identity.",
    imgUrl: "./img/services/ui-ux/visual-design.jpg",
  },
  {
    title: "Interaction Design",
    description: "Design engaging interactions to enhance user experiences.",
    imgUrl: "./img/services/ui-ux/interaction-design.png",
  },
  {
    title: "Usability Testing",
    description: "Evaluate products with real users to identify issues and improve functionality.",
    imgUrl: "./img/services/ui-ux/usability-testing.png",
  },
  {
    title: "Accessibility",
    description: "Ensure inclusive design for people with different abilities.",
    imgUrl: "./img/services/ui-ux/accessibility.jpg",
  },
];

const UIUXDesign = () => {
  const [, setScrollY] = useState(0);
  const paths = [
    { name: "Home", link: "/" },
    { name: "Services", link: "" },
    { name: "UI/UX Design", link: "" },
  ];

  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="page-overview">
        <PageOverView text="UI/UX Design" description="Crafting seamless, visually appealing, and user-friendly digital experiences for the modern world." />
      </div>
      <motion.div
        key="div0"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{ duration: 0.7 }}>
        <div className="service-page">
          <div className="uiux-page">
            <section className="about">
              <h2>What is UI/UX Design?</h2>
              <p>
                UI (User Interface) Design focuses on creating visually appealing interfaces, while UX (User Experience) Design ensures these interfaces provide a seamless and satisfying experience for users.
              </p>
              <img
                src="./img/services/ui-ux.jpg"
                alt="UI/UX Design Overview"
                className="about-image"
              />
            </section>
            <section className="services">
              <h2>Our Key Services</h2>
              <div className="services-grid">
                {services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <img
                      src={service.imgUrl}
                      alt={service.title}
                      className="service-img"
                    />
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>
            </section>
            <section className="benefits">
              <h2>Our Design Process</h2>
              <p>
                Our process combines creativity with user-centered design principles:
              </p>
              <ul>
                <li>Empathize with users</li>
                <li>Define challenges</li>
                <li>Ideate solutions</li>
                <li>Prototype designs</li>
                <li>Test and iterate</li>
              </ul>
            </section>
            <footer className="contact">
              <h2>Get in Touch</h2>
              <p>
                Interested in our UI/UX Design services? <br /> Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
              </p>
            </footer>
          </div>
        </div>
      </motion.div>
      <div className="breadcrumb-container">
        <Breadcrumb paths={paths} />
      </div>
    </>
  );
};

export default UIUXDesign;
